import type { ScrapedImage } from "../../types"

/**
 * How an asset is referenced in a generation request.
 *
 * The backend accepts an asset library id OR a direct media URL for every
 * reference — it resolves both to bytes server-side. Feed images arrive with
 * only a URL and that is fine; there is no reason to register an asset just
 * to obtain an id for media we already host. (`parentAssetId` is the
 * exception: it is a real foreign key, so it still needs an id.)
 */
const mediaRef = (a: ScrapedImage | undefined) => a?.assetId ?? a?.url

export default mediaRef
